export default __webpack_public_path__ + "fonts/contact-img2.svg";